module.exports = __webpack_public_path__ + "static/media/export.20f380b5.svg";